import { isMobilePage, isPCPage } from './utils/env';
import loadYNF from './utils/loadYNF';
import { err } from './utils/report'

interface iconObj { pc: string, mobile: string }

// TODO 未来设计成从后端拿映射表
const IconPackageMap: Record<string, iconObj> = {
  platform: {
    pc: 'ynf-lib-basic/icon',
    mobile: 'ynf-lib-basic-mobile/icon'
  }
  // fanance: {
  //   pc: 'ynf-fanance-basic/icon',
  //   mobile: 'ynf-fanance-basic-mobile/icon'
  // }
  // ...
}
// 计算图标map
const procesIconMap = (domainKey: string, type: 'pc' | 'mb', galleryMap: any) => {
  if (!galleryMap) return null;
  const iconMap: any = {};
  // 每个领域的PC端\移动端图标包中，可能会存在多个图标库
  const galleryKeys = Object.keys(galleryMap);
  galleryKeys.forEach(key => {
    const gallery = galleryMap[key];
    const assets = gallery?.assets ?? [];
    assets.forEach((asset: any) => {
      asset.prefix = gallery.class_prefix;
      iconMap[`${domainKey}-${type}-${gallery?.class_prefix}#${asset?.font_class}`] = asset;
    })
  });

  return iconMap;
}
const IconManager: any = {
  IconObjMap: {},
  IconMap: {},
  getIcon: function (key: string) {
    return this.IconMap[key];
  }
}
// 可以挂在全局
// 获取并加载二方包里的图标资源模块
const IconLoader = async (isMobile: boolean) => {
  const domains = Object.keys(IconPackageMap);
  const iconObjMap: Record<string, { pcIcon: any, mobileIcon: any }> = {};
  const iconMap = {}
  for (const domainKey of domains) {
    const domain = IconPackageMap[domainKey];
    const { pc, mobile } = domain;
    let pcIcon, mobileIcon;
    // 移动端和PC端分别加载
    if (isMobile) {
      mobileIcon = mobile ? await loadYNF(mobile, { errReport: true }) : undefined;
      const mobileIconMap = procesIconMap(domainKey, 'mb', mobileIcon);
      mobileIconMap && Object.assign(iconMap, mobileIconMap);
      if (mobile && !mobileIcon) err(`加载${domainKey}的mobile图标库失败`);
    } else {
      pcIcon = pc ? await loadYNF(pc, { errReport: true }) : undefined;
      const pcIconMap = procesIconMap(domainKey, 'pc', pcIcon);
      pcIconMap && Object.assign(iconMap, pcIconMap);
      if (pc && !pcIcon) err(`加载${domainKey}的pc图标库失败`);
    }
    iconObjMap[domainKey] = {
      pcIcon,
      mobileIcon
    }
  }
  IconManager.IconObjMap = iconObjMap;
  IconManager.IconMap = iconMap;
  return { iconObjMap, iconMap };
}

export default IconLoader;
